// extracted by mini-css-extract-plugin
export default {"base":"CardLayout_base__BYmpe"};